module.exports = __webpack_public_path__ + "static/media/circle-spec.2b647fa1.svg";